import getters from './getters'
import actions from './actions'
import mutations from './mutations'
import { activeMembersActions, activeMembersMutations, getActiveMembersState } from './activeMembers'

export default {
  namespaced: true,
  state: getActiveMembersState,
  getters,
  actions: { ...actions, ...activeMembersActions },
  mutations: { ...mutations, ...activeMembersMutations },
}
